import { notify } from '@hive/component';
import { updateReadyAtom } from '@hive/core/components/hooks/use-app-updater';
import type { useI18n } from '@hive/i18n';
import { track } from '@hive/track';
import { ResetIcon } from '@blocksuite/icons/rc';
import type { createStore } from 'jotai';

import { registerHiveCommand } from './registry';

export function registerHiveUpdatesCommands({
  t,
  store,
  quitAndInstall,
}: {
  t: ReturnType<typeof useI18n>;
  store: ReturnType<typeof createStore>;
  quitAndInstall: () => Promise<void>;
}) {
  const unsubs: Array<() => void> = [];

  unsubs.push(
    registerHiveCommand({
      id: 'hive:restart-to-upgrade',
      category: 'hive:updates',
      icon: <ResetIcon />,
      label: t['com.hive.cmdk.hive.restart-to-upgrade'](),
      preconditionStrategy: () => !!store.get(updateReadyAtom),
      run() {
        track.$.cmdk.updates.quitAndInstall();

        quitAndInstall().catch(err => {
          notify.error({
            title: 'Failed to restart to upgrade',
            message: 'Please restart the app manually to upgrade.',
          });
          console.error(err);
        });
      },
    })
  );

  return () => {
    unsubs.forEach(unsub => unsub());
  };
}
